import { Box, Select, TextField } from 'vopay';
import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'UI';

type SearchFormProps = {
  status: string;
  searchTerm: string;
  handleStatusChange: (event: string) => void;
  handleSearchTermChange: (event: string) => void;
  search: () => void;
};

type FC = FunctionComponent<SearchFormProps>;

const TransactionSearchForm: FC = (props: SearchFormProps) => {
  const { status, searchTerm, handleStatusChange, handleSearchTermChange, search } = props;
  const { t } = useTranslation('translations', { keyPrefix: 'ScheduledTransactions.Details.History.SearchForm' });

  const statusOptions = [
    { label: t('Status.Options.all'), value: 'all' },
    { label: t('Status.Options.completed'), value: 'completed' },
    { label: t('Status.Options.upcoming'), value: 'upcoming' },
    { label: t('Status.Options.cancelled by user'), value: 'cancelled by user' },
    { label: t('Status.Options.pending'), value: 'pending' },
    { label: t('Status.Options.in progress'), value: 'in progress' },
    { label: t('Status.Options.successful'), value: 'successful' },
    { label: t('Status.Options.failed'), value: 'failed' },
    { label: t('Status.Options.cancelled'), value: 'cancelled' },
    { label: t('Status.Options.cancellation requested'), value: 'cancellation requested' },
  ];

  return (
    <Box jc="sb" flx="row" width="100%">
      <Box gap="sm" wrap="wrap">
        <Box width="200px">
          <Select
            version="2"
            placeholder={t('Status.placeholder')}
            options={statusOptions}
            name="status"
            value={status}
            onBlur={() => {}}
            onChange={(e) => {
              handleStatusChange(e.target.value);
            }}
            sort={false}
          />
        </Box>
        <Box>
          <TextField
            key="AccountSearchKeyword"
            name="AccountSearchKeyword"
            placeholder={t('keywordPlaceholder')}
            value={searchTerm}
            onBlur={() => {}}
            onChange={(e) => {
              handleSearchTermChange(e.target.value);
            }}
            variant="outlineShadow"
          />
        </Box>
        <Button
          id="search-schedule-transactions"
          size="small"
          colorScheme="primary"
          onClick={() => {
            search();
          }}
        >
          {t('searchButton')}
        </Button>
      </Box>
    </Box>
  );
};

export default TransactionSearchForm;
